export default __webpack_public_path__ + "static/media/round-checkmark.2a094dc0.svg";